<template>
  <div class="account">
    <Header />
    <OrderDetails />
    <Footer />
  </div>
</template>

<script>
import Header from "../../src/components/template/Header";
import Footer from "../../src/components/template/Footer";
import OrderDetails from "../../src/components/account/Orders/OrderDetails";
export default {
  components: {
    Header,
    Footer,
    OrderDetails,
  },
};
</script>